import KfzEdit from "../components/KfzEdit";
import {connect} from "react-redux";
import {isOnline} from "../actions/userActions";
import {
	deleteKfz,
	deleteKfzModel,
	fetchKfzList,
	fetchKfzModels,
	updateKfz,
	uploadLogoForKfz
} from "../actions/kfzActions";
import {push} from "react-router-redux";
import isFunc from 'lodash/isFunction';
import {showSnackbar} from "../actions/snachbarActions";
import {isProcessing} from "../actions/processingActions";
import {PROC_KFZ, PROC_KFZ_UPLOAD} from "../actions";
import {ROUTE_KFZ} from "../routes";

const m2s = (state, props) => {
	const kfz_id = Number(props.match.params.kfz_id);
	return {
		kfz_id,
		kfz: state.kfz.list.find(kfz => kfz.kfz_id === kfz_id),
		isUpdating: isProcessing(state, PROC_KFZ, kfz_id),
		isUploading: isProcessing(state, PROC_KFZ_UPLOAD, kfz_id)
	};
};
const m2d = (dispatch, props) => {
	const kfz_id = Number(props.match.params.kfz_id);
	dispatch(isOnline(() => {
		dispatch(fetchKfzList(kfz_id, false, () => {
			dispatch(fetchKfzModels(kfz_id));
		}));
	}));
	return {
		push: to => dispatch(push(to)),
		onSave: (kfz, onSuccess) => dispatch(updateKfz(kfz, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.kfz.updated'));
		})),
		onDelete: (kfz, onSuccess) => dispatch(deleteKfz(kfz, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.kfz.deleted'));
			dispatch(push(ROUTE_KFZ));
		})),
		onModelDelete: (kfz, hsn, tsn, onSuccess) => dispatch(deleteKfzModel(kfz, hsn, tsn, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.kfz.model.deleted'));
		})),
		onUploadLogo: (kfz, image, onSuccess) => dispatch(uploadLogoForKfz(kfz, image, result => {
			isFunc(onSuccess) && onSuccess(result);
			dispatch(showSnackbar('snackbar.kfz.logo-uploaded'));
		}))
	};
};

export default connect(m2s, m2d)(KfzEdit);


// WEBPACK FOOTER //
// ./src/containers/KfzEditController.js